export default __webpack_public_path__ + "static/Claims-Upload-&-Summary-3cd7ef8126a8667ba36c50035080ad4d.png";